import { translate } from "@classdojo/web/utils/translate";

export type BedtimeStoryEpisode = {
  title: string;
  seriesTitle: string;
  releaseDate?: Date;
  imgSrc: string;
  fullscreenImgSrc: string;
  audioSrc: string;
  audioDuration: string;
  loggingId: string;
};

export const episodes = () => [
  //Optimism Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.optimism_series.optimism_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.optimism_series.optimism"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep1/Mojo_EpCovers_10.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep1/Mojo_EpCovers_10.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/optimism_1.mp3",
    audioDuration: "3",
    loggingId: "optimism_1",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.optimism_series.optimism_2"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.optimism_series.optimism"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep2/Mojo_EpCovers_11.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep2/Mojo_EpCovers_11.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/optimism_2.mp3",
    audioDuration: "3",
    loggingId: "optimism_2",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.optimism_series.optimism_3"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.optimism_series.optimism"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep3/Mojo_EpCovers_12.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/positive-thinking/ep3/Mojo_EpCovers_12.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/optimism_3.mp3",
    audioDuration: "3",
    loggingId: "optimism_3",
  },

  //Respect Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.respect_series.respect_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.respect_series.respect"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep1/Mojo_EpCovers_07.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep1/Mojo_EpCovers_07.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/respect_1.mp3",
    audioDuration: "3",
    loggingId: "respect_1",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.respect_series.respect_2"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.respect_series.respect"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep2/Mojo_EpCovers_08.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep2/Mojo_EpCovers_08.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/respect_2.mp3",
    audioDuration: "3",
    loggingId: "respect_2",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.respect_series.respect_3"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.respect_series.respect"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep3/Mojo_EpCovers_09.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/activities/respect/ep3/Mojo_EpCovers_09.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/respect_3.mp3",
    audioDuration: "3",
    loggingId: "respect_3",
  },

  //Big Challenges Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.big_challenges_series.big_challenges_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.big_challenges_series.big_challenges"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep1/Mojo_EpCovers_04.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep1/Mojo_EpCovers_04.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/big_challenges_1.mp3",
    audioDuration: "3",
    loggingId: "big_challenges_1",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.big_challenges_series.big_challenges_2"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.big_challenges_series.big_challenges"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep2/Mojo_EpCovers_05.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep2/Mojo_EpCovers_05.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/big_challenges_2.mp3",
    audioDuration: "3",
    loggingId: "big_challenges_2",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.big_challenges_series.big_challenges_3"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.big_challenges_series.big_challenges"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep3/Mojo_EpCovers_06.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/big-challenges/ep3/Mojo_EpCovers_06.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/big_challenges_3.mp3",
    audioDuration: "3",
    loggingId: "big_challenges_3",
  },

  //Moods and Attitudes Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.moods_and_attitudes_series.moods_and_attitudes_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.moods_and_attitudes_series.moods_and_attitudes"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep1/Mojo_EpCovers_01.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep1/Mojo_EpCovers_01.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/moods_and_attitudes_1.mp3",
    audioDuration: "3",
    loggingId: "moods_and_attitudes_1",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.moods_and_attitudes_series.moods_and_attitudes_2"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.moods_and_attitudes_series.moods_and_attitudes"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep2/Mojo_EpCovers_02.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep2/Mojo_EpCovers_02.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/moods_and_attitudes_2.mp3",
    audioDuration: "3",
    loggingId: "moods_and_attitudes_2",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.moods_and_attitudes_series.moods_and_attitudes_3"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.moods_and_attitudes_series.moods_and_attitudes"),
    releaseDate: new Date("2099-04-30"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep3/Mojo_EpCovers_03.jpg",
    fullscreenImgSrc:
      "https://static.classdojo.com/img/ideas_platform/activities/moods-and-attitudes/ep3/Mojo_EpCovers_03.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/moods_and_attitudes_3.mp3",
    audioDuration: "4",
    loggingId: "moods_and_attitudes_3",
  },

  //Mindfulness Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.mindfulness_series.mindfulness_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.mindfulness_series.mindfulness"),
    releaseDate: new Date("2020-07-08"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s04e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s04e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/mindfulness_1.mp3",
    audioDuration: "3",
    loggingId: "mindfulness_1",
  },

  //Empathy Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.empathy_series.empathy_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.empathy_series.empathy"),
    releaseDate: new Date("2020-06-23"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/empathy_1.mp3",
    audioDuration: "5",
    loggingId: "empathy_1",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.empathy_series.empathy_2"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.empathy_series.empathy"),
    releaseDate: new Date("2020-06-23"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e02/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e02/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/empathy_2.mp3",
    audioDuration: "4",
    loggingId: "empathy_2",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.empathy_series.empathy_3"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.empathy_series.empathy"),
    releaseDate: new Date("2020-06-23"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e03/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s03e03/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/empathy_3.mp3",
    audioDuration: "5",
    loggingId: "empathy_3",
  },

  //Perseverance Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.perseverance_series.perseverance_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.perseverance_series.perseverance"),
    releaseDate: new Date("2020-06-07"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/perseverance_1.mp3",
    audioDuration: "4",
    loggingId: "perseverance_1",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.perseverance_series.perseverance_2"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.perseverance_series.perseverance"),
    releaseDate: new Date("2020-06-07"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e02/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e02/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/perseverance_2.mp3",
    audioDuration: "4",
    loggingId: "perseverance_2",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.perseverance_series.perseverance_3"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.perseverance_series.perseverance"),
    releaseDate: new Date("2020-06-07"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e03/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s02e03/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/perseverance_3.mp3",
    audioDuration: "4",
    loggingId: "perseverance_3",
  },

  //Growth Mindset Series:
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset_1"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset"),
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e01/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e01/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_1.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_1",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset_2"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset"),
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e02/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e02/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_2.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_2",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset_3"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset"),
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e03/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e03/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_3.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_3",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset_4"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset"),
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e04/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e04/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_4.mp3",
    audioDuration: "3",
    loggingId: "growth_mindset_4",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset_5"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.growth_mindset_series.growth_mindset"),
    releaseDate: new Date("2020-05-25"),
    imgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e05/cover.jpg",
    fullscreenImgSrc: "https://static.classdojo.com/img/ideas_platform/ideas/the_mojo_show/s01e05/cover.jpg",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/growth_mindset_5.mp3",
    audioDuration: "4",
    loggingId: "growth_mindset_5",
  },

  //Originally released stories (no release date = will be available to everyone anytime)
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.episode_titles.mind_vacation"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.meditation_series.meditation"),
    imgSrc: "/static/images/bedtime_wakeup.png",
    fullscreenImgSrc: "/static/images/bedtime_wakeup.png",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/mindvacation-2019.mp3",
    audioDuration: "4",
    loggingId: "mind_vacation",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.episode_titles.bedtime_meditation"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.meditation_series.meditation"),
    imgSrc: "/static/images/bedtime_sleep.png",
    fullscreenImgSrc: "/static/images/bedtime_sleep.png",
    audioSrc: "https://static.classdojo.com/toolkit-static/bedtime/bedtime-meditation-2019.mp3",
    audioDuration: "3",
    loggingId: "bedtime_meditation",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.episode_titles.bruce"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.history_of_greatness_series.history_of_greatness"),
    imgSrc: "/static/images/history_bruce.png",
    fullscreenImgSrc: "/static/images/history_bruce_portrait.png",
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/bruce-lee.mp3",
    audioDuration: "10",
    loggingId: "bruce_lee",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.episode_titles.frida"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.history_of_greatness_series.history_of_greatness"),
    imgSrc: "/static/images/history_frida.png",
    fullscreenImgSrc: "/static/images/history_frida_portrait.png",
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/frida-kahlo.mp3",
    audioDuration: "14",
    loggingId: "frida_kahlo",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.episode_titles.harry"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.history_of_greatness_series.history_of_greatness"),
    imgSrc: "/static/images/history_harry.png",
    fullscreenImgSrc: "/static/images/history_harry_portrait.png",
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/harry-houdini.mp3",
    audioDuration: "13",
    loggingId: "harry_houdini",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.episode_titles.jane"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.history_of_greatness_series.history_of_greatness"),
    imgSrc: "/static/images/history_jane.png",
    fullscreenImgSrc: "/static/images/history_jane_portrait.png",
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/jane-goodall.mp3",
    audioDuration: "13",
    loggingId: "jane_goodall",
  },
  {
    title: translate("dojo.beyond:toolkit.bedtime_stories.episode_titles.mae"),
    seriesTitle: translate("dojo.beyond:toolkit.bedtime_stories.history_of_greatness_series.history_of_greatness"),
    imgSrc: "/static/images/history_mae.png",
    fullscreenImgSrc: "/static/images/history_mae_portrait.png",
    audioSrc: "https://static.classdojo.com/toolkit-static/history_of_greatness/mae-jemison.mp3",
    audioDuration: "10",
    loggingId: "mae_jemison",
  },
];
